var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"after-min"},[_c('div',{staticClass:"after-top"},[_vm._v(" La verificación es exitosa, haga clic para ir al sitio web ")]),_c('div',{},[_c('button',{staticClass:"btn",on:{"click":_vm.home}},[_vm._v("CONTINUAR")])])])}
var staticRenderFns = []

export { render, staticRenderFns }